import { createModelStore } from '@/shared/stores/create-model-store'
import { model16InitialModel } from './initial-state'
import { model16DimensionHandlers } from './dimensions'

export const useModel16Store = createModelStore({
  initialModel: model16InitialModel,
  dimensionHandlers: model16DimensionHandlers,
})
